/* eslint-disable @nx/enforce-module-boundaries */
import { bffHeadersInterceptor } from '@credit-web/shared/infra'
import axios from 'axios'
import { CREDIT_API_ENDPOINT } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientCredit = httpClientFactory({
  baseURL: CREDIT_API_ENDPOINT(),
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  requestInterceptor: bffHeadersInterceptor,
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
